import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import SelectedTag from '@/modules/corporate/modules/tags/components/SelectedTag';
import useUpdateActionItem from '@/modules/tasks/features/actionItems/hooks/useUpdateActionItem';
import { EntityTagsInput, EntityTagType } from '@/types/schema';

interface AttachedTagsContainerProps {
  tag: EntityTagType;
  taskId: string;
  taskTags: EntityTagType[];
  disableInteractiveTooltip?: boolean;
}

function AttachedTagsContainer(props: AttachedTagsContainerProps) {
  useTranslation('Tags');
  const { updateActionItem } = useUpdateActionItem();

  const onUpdateTag = useCallback(
    (tags?: EntityTagsInput | null) =>
      updateActionItem({ data: { actionItemId: props.taskId, tags } }),
    [props.taskId, updateActionItem],
  );

  return (
    <SelectedTag
      disableInteractiveTooltip={props.disableInteractiveTooltip}
      filters={{
        parentId: props.taskId,
      }}
      tag={props.tag}
      tags={props.taskTags}
      onUpdateTag={onUpdateTag}
    />
  );
}

export default AttachedTagsContainer;
